import { useQuery } from "react-query";
import { API_KEY_GET_LANDING_PAGE_INFO } from "../utils";
import { getLandingPageInfo } from "../api";

export const useGetLandingPageInfo = (params) => {
  return useQuery([API_KEY_GET_LANDING_PAGE_INFO, params], () =>
    getLandingPageInfo(params)
  );
};
